import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { UploadMacAddressService } from "../../shared/services/upload-mac-address/upload-mac-address.service";
import Swal from "sweetalert2";
import { first } from "rxjs/operators";
@Component({
  selector: 'app-mac-address-list',
  templateUrl: './mac-address-list.component.html',
  styleUrls: ['./mac-address-list.component.scss']
})
export class MacAddressListComponent implements OnInit {
  filter: any = {
    key: ""
  };
  /*** for paginaton start */
  pageSize = 25;
  currentPage = 1;
  macaddressCount = 0;
  doc: any;
  downloadurl = "";
  /** end pagination */
  macaddress: any = [];
  sender = "mac-address-list";

  constructor(
    private router: Router,
    private uploadMacAddressService: UploadMacAddressService
  ) { }
  ngOnInit() {
    this.searchMacAddress();
  }

  uploadMacAddress() {
    this.router.navigate(["manager/upload-mac-address/new"]);
  }

  OnClick(center_id) {
    this.router.navigate(["manager/mac-address-details/" + center_id]);
  }

  onAdd() {
    this.router.navigate(["manager/mac-address-details/new"]);
  }

  searchMacAddress() {
    this.uploadMacAddressService
      .searchMacAddressList(this.currentPage, this.pageSize, this.filter)
      .pipe(first())
      .subscribe(res => {
        this.macaddressCount = res["count"];
        this.macaddress = res["data"];
      });
  }

  fetchMacAddress(e) {
    this.currentPage = e;
    this.searchMacAddress();
  }

  clear() {
    this.filter.key = "";
    this.searchMacAddress();
  }

  onDelete() {
    Swal.fire({
      title: "Are you sure?",
      text: "MAC Address data will be deleted. This action can't be reversed!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it"
    }).then(result => {
      if (result.value) {
        Swal.fire("Deleted!", "MAC address is deleted.", "success");
        this.uploadMacAddressService
          .deleteAll(this.macaddress)
          .pipe(first())
          .subscribe(res => {
            this.searchMacAddress();
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Cancelled", "MAC address  is Not Deleted:)", "error");
      }
    });
  }

}
